import { supabaseClient } from "@/lib/supabase";
import type { InputT } from "@/types/database/forms";
import { queryOptions, useQuery } from "@tanstack/react-query";

// Function to select multiple inputs by an array of UUIDs
export async function selectInputsByIds(inputIds: string[]): Promise<InputT[]> {
	if (!inputIds || inputIds.length === 0) return [];

	console.log("seelecting inputs by ids", inputIds);
	const { data, error } = await supabaseClient
		.from("inputs")
		.select()
		.in("input_id", inputIds);

	if (error) throw error;
	return data as InputT[];
}

export const selectInputsByIdsQueryOptions = (inputIds: string[]) => {
	// Explicitly check if inputIds is a valid array before using it
	const isEnabled = Array.isArray(inputIds) && inputIds.length > 0;
	// Ensure the queryKey part is always an array, even if inputIds is somehow invalid
	const safeQueryKeyIds = Array.isArray(inputIds) ? inputIds : [];

	return queryOptions({
		queryKey: ["inputs", { input_ids: safeQueryKeyIds }],
		// selectInputsByIds already handles invalid inputIds internally
		queryFn: async () => selectInputsByIds(inputIds),
		enabled: isEnabled,
	});
};

export function useSelectInputsByIds(inputIds: string[]) {
	// Ensure inputIds is always an array before passing to options
	const safeInputIds = Array.isArray(inputIds)
		? inputIds.filter((id) => typeof id === "string")
		: [];
	const options = selectInputsByIdsQueryOptions(safeInputIds);
	return useQuery(options);
}
